import { Archive, Copy, Trash2, X } from 'lucide-react';

interface BulkActionBarProps {
  selectedCount: number;
  onArchive: () => void;
  onDuplicate: () => void;
  onDelete: () => void;
  onClearSelection: () => void;
}

const BulkActionBar = ({
  selectedCount,
  onArchive,
  onDuplicate,
  onDelete,
  onClearSelection,
}: BulkActionBarProps) => {
  if (selectedCount === 0) return null;

  return (
    <div className="mb-4 overflow-hidden">
      <div
        className="bg-white border border-blue-200 rounded-xl shadow-md px-4 py-3 flex items-center gap-3 animate-slide-down"
        style={{ animation: 'slideDown 0.2s ease-out' }}
      >
        {/* Count + deselect */}
        <div className="flex items-center gap-2 min-w-0">
          <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-blue-600 text-white text-xs font-bold shrink-0">
            {selectedCount}
          </span>
          <span className="text-sm font-medium text-gray-700 whitespace-nowrap">
            session{selectedCount > 1 ? 's' : ''} sélectionnée{selectedCount > 1 ? 's' : ''}
          </span>
          <button
            onClick={onClearSelection}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            title="Désélectionner tout"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        {/* Divider */}
        <div className="h-6 w-px bg-gray-200 shrink-0" />

        {/* Actions */}
        <div className="flex items-center gap-1">
          <button
            onClick={onArchive}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium text-amber-700 hover:bg-amber-50 border border-transparent hover:border-amber-200 transition-all"
            title="Archiver la sélection"
          >
            <Archive className="h-4 w-4" />
            <span className="hidden sm:inline">Archiver</span>
          </button>

          <button
            onClick={onDuplicate}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium text-blue-700 hover:bg-blue-50 border border-transparent hover:border-blue-200 transition-all"
            title="Dupliquer la sélection"
          >
            <Copy className="h-4 w-4" />
            <span className="hidden sm:inline">Dupliquer</span>
          </button>

          <button
            onClick={onDelete}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium text-red-700 hover:bg-red-50 border border-transparent hover:border-red-200 transition-all"
            title="Supprimer la sélection"
          >
            <Trash2 className="h-4 w-4" />
            <span className="hidden sm:inline">Supprimer</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionBar;
